import { Avatar, type AvatarSize } from '../atoms/Avatar';
import styles from './Persona.module.css';

export interface PersonaProps {
  name: string;
  /** Second line, e.g. the e-mail address. */
  secondary?: string;
  src?: string;
  size?: Extract<AvatarSize, 'sm' | 'md' | 'lg'>;
  shape?: 'circle' | 'hexagon';
}

/** Avatar with name and a secondary line. */
export function Persona({ name, secondary, src, size = 'md', shape = 'circle' }: PersonaProps) {
  return (
    <span className={`${styles.persona} ${styles[size]}`}>
      <Avatar name={name} size={size} shape={shape} decorative {...(src ? { src } : {})} />
      <span className={styles.text}>
        <span className={styles.name}>{name}</span>
        {secondary && <span className={styles.secondary}>{secondary}</span>}
      </span>
    </span>
  );
}
